module.exports = __webpack_public_path__ + "static/divider4-18dafd89717ee461b5c8d357dc55afd8.svg";